import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2ea46345"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "param-table"
};
const _hoisted_2 = {
  class: "param-table__head"
};
const _hoisted_3 = {
  class: "param-grid head-grid"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "参数名称", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "参数来源", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "参数值", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "备注", -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "创建时间", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "更新时间", -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-right"
}, "操作", -1));
const _hoisted_11 = {
  class: "param-grid"
};
const _hoisted_12 = {
  class: "cell name-cell copyable"
};
const _hoisted_13 = {
  class: "cell-text"
};
const _hoisted_14 = {
  class: "cell code-cell copyable"
};
const _hoisted_15 = {
  class: "code-pill"
};
const _hoisted_16 = {
  class: "cell"
};
const _hoisted_17 = {
  class: "cell value-cell copyable"
};
const _hoisted_18 = {
  class: "value-inner"
};
const _hoisted_19 = ["title"];
const _hoisted_20 = ["title"];
const _hoisted_21 = {
  class: "cell remark-cell"
};
const _hoisted_22 = ["title"];
const _hoisted_23 = {
  class: "cell time-cell"
};
const _hoisted_24 = ["title"];
const _hoisted_25 = {
  class: "cell time-cell"
};
const _hoisted_26 = ["title"];
const _hoisted_27 = {
  class: "cell text-right action-cell"
};
const _hoisted_28 = {
  key: 1,
  class: "empty-row"
};
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "empty-row__text"
}, "当前模块暂无参数", -1));
const _hoisted_30 = [_hoisted_29];
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "新增参数", -1));
import { Modal } from 'ant-design-vue';
import { LockOutlined, PlusOutlined } from '@ant-design/icons-vue';
import { PARAM_SOURCE_LABEL } from '../types';
import CopyButton from './CopyButton.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'ParamTable',
  props: {
    params: null
  },
  emits: ["add", "edit", "log", "delete"],
  setup(__props, {
    emit
  }) {
    /**
     * 参数表格组件（嵌在模块卡片内）
     * - 表头 8 列：参数名称 / 参数编码（带锁图标提示）/ 参数来源 / 参数值 / 备注 / 创建时间 / 更新时间 / 操作
     * - 参数来源按枚举值显示不同颜色 tag
     * - 参数值按来源类型解析：CUSTOM_TEXT 直接展示文本；枚举型解析 JSON 后用 chip 展示
     * - 参数名称 / 参数编码 / 参数值 hover 时显示复制 icon，点击复制原始值（参数值复制 paramValue 原始字符串）
     * - 行操作 编辑 / 删除（删除带二次确认）
     * - 末尾「+ 新增参数」虚线按钮
     *
     * Emits：add / edit / delete
     */
    /**
     * 参数来源 → 标签 CSS class
     * 不同来源对应不同语义色
     */
    const SOURCE_CLASS_MAP = {
      CUSTOM_TEXT: 'src-text',
      CONTACTS: 'src-contact',
      APP: 'src-product',
      CHANNEL: 'src-channel'
    };
    const getSourceClass = source => SOURCE_CLASS_MAP[source || ''] || 'src-default';
    const getSourceLabel = source => PARAM_SOURCE_LABEL[source || ''] || source || '-';
    /**
     * 解析参数值用于表格展示
     *
     * 返回 { text, chips }：
     * - chips 非空时按一颗颗 chip 渲染（枚举型来源）
     * - chips 为空但 text 有内容时按纯文本渲染（自定义文本）
     *
     * 解析规则按 paramSource 分支：
     * - CUSTOM_TEXT：原始字符串直接展示
     * - CONTACTS：JSON [{name, userName, userId}] → 优先取 name 字段
     * - APP：JSON [{appName, dbtId}] → 优先取产品名
     * - CHANNEL：JSON ["alipay", "wxpay"] → 直接渲染编码
     *
     * 解析失败时降级展示原始字符串，避免渲染崩溃
     */
    const formatValue = p => {
      var _p$paramValue;
      const src = p.paramSource;
      const raw = (_p$paramValue = p.paramValue) !== null && _p$paramValue !== void 0 ? _p$paramValue : '';
      if (src === 'CUSTOM_TEXT' || !raw) {
        return {
          text: String(raw || '-'),
          chips: []
        };
      }
      let arr = [];
      try {
        const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
        if (Array.isArray(parsed)) arr = parsed;
      } catch {
        // 解析失败时降级为原始字符串
        return {
          text: String(raw),
          chips: []
        };
      }
      if (!arr.length) return {
        text: '-',
        chips: []
      };
      const chips = arr.map(item => {
        var _ref, _ref2, _obj$name, _ref3, _obj$appName;
        if (typeof item === 'string') return item;
        if (item && typeof item === 'object') {
          const obj = item;
          switch (src) {
            case 'CONTACTS':
              return String((_ref = (_ref2 = (_obj$name = obj.name) !== null && _obj$name !== void 0 ? _obj$name : obj.userName) !== null && _ref2 !== void 0 ? _ref2 : obj.userId) !== null && _ref !== void 0 ? _ref : '');
            case 'APP':
              return String((_ref3 = (_obj$appName = obj.appName) !== null && _obj$appName !== void 0 ? _obj$appName : obj.dbtId) !== null && _ref3 !== void 0 ? _ref3 : '');
            default:
              return JSON.stringify(item);
          }
        }
        return String(item !== null && item !== void 0 ? item : '');
      });
      return {
        text: chips.join('、'),
        chips: chips.filter(Boolean)
      };
    };
    /**
     * 取参数值的可复制内容
     * - CUSTOM_TEXT：复制原始字符串（保留多行 / JSON 等格式）
     * - 枚举型：复制后端存储的 JSON 字符串（方便研发联调）
     * 空值返回空字符串（CopyButton 拿到空字符串不显示）
     */
    const getCopyableValue = p => {
      var _p$paramValue2;
      return (_p$paramValue2 = p.paramValue) !== null && _p$paramValue2 !== void 0 ? _p$paramValue2 : '';
    };
    /**
     * 是否大文本类型
     * - 后端明确标 LARGE_TEXT → 大文本
     * - 没标但内容里含换行符 → 兜底当作大文本（避免被压成一行）
     */
    const isLargeText = p => {
      if (p.paramSource !== 'CUSTOM_TEXT') return false;
      if (p.paramValueType === 'LARGE_TEXT') return true;
      return typeof p.paramValue === 'string' && p.paramValue.includes('\n');
    };
    /**
     * 删除参数
     * 二次确认；onOk 返回 Promise 让确定按钮自动 loading 防连点
     */
    const handleDelete = p => {
      Modal.confirm({
        title: '确认删除参数',
        content: `确定要删除参数「${p.paramName || '未命名参数'}」吗？此操作不可恢复。`,
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        centered: true,
        onOk: () => Promise.resolve(emit('delete', p))
      });
    };
    return (_ctx, _cache) => {
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_button = _resolveComponent("a-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", null, [_createTextVNode(" 参数编码 "), _createVNode(_unref(LockOutlined), {
        class: "head-lock",
        title: "参数编码首次填写后锁定不可编辑"
      })]), _hoisted_5, _hoisted_6, _hoisted_7, _hoisted_8, _hoisted_9, _hoisted_10])]), __props.params.length ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(__props.params, p => {
        return _openBlock(), _createElementBlock("div", {
          key: p.id,
          class: "param-row"
        }, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createVNode(_component_a_tooltip, {
          title: p.paramName || '(未命名参数)',
          placement: "topLeft"
        }, {
          default: _withCtx(() => [_createElementVNode("span", _hoisted_13, _toDisplayString(p.paramName || '(未命名参数)'), 1)]),
          _: 2
        }, 1032, ["title"]), p.paramName ? (_openBlock(), _createBlock(CopyButton, {
          key: 0,
          text: p.paramName,
          label: `参数名称「${p.paramName}」`
        }, null, 8, ["text", "label"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_14, [_createElementVNode("code", _hoisted_15, _toDisplayString(p.paramCode || '-'), 1), p.paramCode ? (_openBlock(), _createBlock(CopyButton, {
          key: 0,
          text: p.paramCode,
          label: `参数编码「${p.paramCode}」`
        }, null, 8, ["text", "label"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_16, [_createElementVNode("span", {
          class: _normalizeClass(["source-tag", getSourceClass(p.paramSource)])
        }, _toDisplayString(getSourceLabel(p.paramSource)), 3)]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [formatValue(p).chips.length ? (_openBlock(true), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList(formatValue(p).chips, (v, idx) => {
          return _openBlock(), _createElementBlock("span", {
            key: idx,
            class: "value-chip"
          }, _toDisplayString(v), 1);
        }), 128)) : isLargeText(p) && formatValue(p).text && formatValue(p).text !== '-' ? (_openBlock(), _createElementBlock("pre", {
          key: 1,
          class: "value-pre",
          title: formatValue(p).text
        }, _toDisplayString(formatValue(p).text), 9, _hoisted_19)) : (_openBlock(), _createElementBlock("span", {
          key: 2,
          class: _normalizeClass(["cell-text", {
            dim: !formatValue(p).text || formatValue(p).text === '-'
          }]),
          title: formatValue(p).text
        }, _toDisplayString(formatValue(p).text || '-'), 11, _hoisted_20))]), getCopyableValue(p) ? (_openBlock(), _createBlock(CopyButton, {
          key: 0,
          text: getCopyableValue(p),
          label: '参数值'
        }, null, 8, ["text"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_21, [_createElementVNode("span", {
          class: "cell-text dim",
          title: p.remark || ''
        }, _toDisplayString(p.remark || '-'), 9, _hoisted_22)]), _createElementVNode("div", _hoisted_23, [_createElementVNode("span", {
          class: "cell-text dim",
          title: p.createTime || ''
        }, _toDisplayString(p.createTime || '-'), 9, _hoisted_24)]), _createElementVNode("div", _hoisted_25, [_createElementVNode("span", {
          class: "cell-text dim",
          title: p.updateTime || ''
        }, _toDisplayString(p.updateTime || '-'), 9, _hoisted_26)]), _createElementVNode("div", _hoisted_27, [_createVNode(_component_a_button, {
          size: "small",
          type: "link",
          class: "row-btn",
          onClick: $event => _ctx.$emit('edit', p)
        }, {
          default: _withCtx(() => [_createTextVNode("编辑")]),
          _: 2
        }, 1032, ["onClick"]), _createVNode(_component_a_button, {
          size: "small",
          type: "link",
          class: "row-btn",
          onClick: $event => _ctx.$emit('log', p)
        }, {
          default: _withCtx(() => [_createTextVNode("日志")]),
          _: 2
        }, 1032, ["onClick"]), _createVNode(_component_a_button, {
          size: "small",
          type: "link",
          class: "row-btn row-btn--danger",
          onClick: $event => handleDelete(p)
        }, {
          default: _withCtx(() => [_createTextVNode("删除")]),
          _: 2
        }, 1032, ["onClick"])])])]);
      }), 128)) : (_openBlock(), _createElementBlock("div", _hoisted_28, _hoisted_30)), _createElementVNode("button", {
        class: "param-add",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('add'))
      }, [_createVNode(_unref(PlusOutlined)), _hoisted_31])]);
    };
  }
});